import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShieldCheck, X, MapPin } from 'lucide-react';
// Nombres y apellidos argentinos comunes
const firstNames = ['Martín', 'Lucas', 'Nicolás', 'Federico', 'Joaquín', 'Mateo', 'Tomás', 'Sebastián', 'Agustín', 'Franco', 'Diego', 'Bruno', 'Ezequiel', 'Gonzalo', 'Camila', 'Sofía', 'Valentina', 'Martina', 'Lucía', 'Florencia', 'Julieta', 'Micaela', 'Carolina', 'Daniela', 'Brenda', 'Ailén', 'Rocío', 'Antonella'];
const lastInitials = ['M.', 'G.', 'R.', 'L.', 'P.', 'S.', 'F.', 'A.', 'B.', 'C.', 'D.', 'V.', 'T.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Paraná', 'Corrientes', 'Tigre', 'Quilmes', 'San Isidro', 'Lanús', 'Avellaneda', 'Bariloche', 'Ushuaia'];
const offers = ['Entrena en Casa™ Megapack', 'Entrena en Casa™ + 3 Bonus'];
const timeAgo = ['hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos', 'hace 8 minutos', 'hace 11 minutos', 'hace 14 minutos', 'hace unos segundos'];
type Purchase = {
  id: number;
  name: string;
  city: string;
  offer: string;
  ago: string;
};
const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
const generatePurchase = (id: number): Purchase => ({
  id,
  name: `${pick(firstNames)} ${pick(lastInitials)}`,
  city: pick(cities),
  offer: pick(offers),
  ago: pick(timeAgo)
});
export function PurchasePopup() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  useEffect(() => {
    let counter = 0;
    let hideTimer: ReturnType<typeof setTimeout>;
    let showTimer: ReturnType<typeof setTimeout>;
    const showNext = () => {
      counter += 1;
      setCurrent(generatePurchase(counter));
      // Visible durante ~5s
      hideTimer = setTimeout(() => {
        setCurrent(null);
        // Próximo en 40-60s
        const nextDelay = 40000 + Math.random() * 20000;
        showTimer = setTimeout(showNext, nextDelay);
      }, 5000);
    };
    // Primer popup tras 8s (no apenas carga la página)
    showTimer = setTimeout(showNext, 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, []);
  const handleClose = () => setCurrent(null);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] sm:max-w-sm pointer-events-none" aria-live="polite" aria-atomic="true" data-id="element-181">
      <AnimatePresence data-id="element-182">
        {current && <motion.div key={current.id} initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-zinc-900/95 backdrop-blur border border-zinc-700 rounded-xl shadow-2xl shadow-black/40 p-3 pr-8 flex items-center gap-3 relative" role="status" data-id="element-183">
            {/* Icono verificado */}
            <div className="shrink-0 w-10 h-10 rounded-full bg-green-500/15 border border-green-500/30 flex items-center justify-center" data-id="element-184">
              <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-185" />
            </div>

            <div className="min-w-0 flex-1" data-id="element-186">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-187">
                <span className="text-[10px] font-bold uppercase tracking-wider text-green-400" data-id="element-188">
                  Compra verificada
                </span>
                <span className="w-1 h-1 rounded-full bg-zinc-600" data-id="element-189" />
                <span className="text-[10px] text-zinc-500" data-id="element-190">{current.ago}</span>
              </div>
              <p className="text-sm text-white font-medium leading-snug truncate" data-id="element-191">
                <span className="font-bold" data-id="element-192">{current.name}</span> compró{' '}
                <span className="text-brand-400" data-id="element-193">{current.offer}</span>
              </p>
              <div className="flex items-center gap-1 text-[11px] text-zinc-400 mt-0.5" data-id="element-194">
                <MapPin className="w-3 h-3" data-id="element-195" />
                <span className="truncate" data-id="element-196">{current.city}, Argentina</span>
              </div>
            </div>

            <button onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-197">
              <X className="w-3.5 h-3.5" data-id="element-198" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}